import { render, staticRenderFns } from "./TaskFormDialog.vue?vue&type=template&id=54b49d89&scoped=true&"
import script from "./TaskFormDialog.vue?vue&type=script&lang=js&"
export * from "./TaskFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskFormDialog.vue?vue&type=style&index=0&id=54b49d89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b49d89",
  null
  
)

export default component.exports